import { useParams } from 'react-router-dom';
import { CreateNewLoanForm, CreateNewLoanPageHeader } from './components';

const CreateNewLoan = () => {
  const { id } = useParams();

  return (
    <div className="d-flex flex-column gap-10 p-10">
      <CreateNewLoanPageHeader />
      <CreateNewLoanForm id={id} />
    </div>
  );
};

export default CreateNewLoan;
